import { useQuery } from "@tanstack/react-query";
import { Building2 } from "lucide-react";
import { useTranslations } from "use-intl";

import { Button } from "@lawline/ui/components/button";

import { CommunicationDialog } from "@platform/features/communication/communication-dialog";
import { pendingCommunicationQueryOptions } from "@platform/features/communication/communication.queries";

// "Request Enterprise" CTA on the billing page; opens the shared message dialog,
// sending the note to staff as an upgrade_request. Once a request is open the
// button locks to "Requested" so the tenant can't file a duplicate.
export function EnterpriseRequestDialog() {
	const t = useTranslations("enterpriseRequest");
	const { data } = useQuery(pendingCommunicationQueryOptions("upgrade_request"));

	if (data?.pending) {
		return (
			<Button variant="outline" className="self-start" disabled>
				<Building2 className="size-4" />
				{t("requested")}
			</Button>
		);
	}

	return (
		<CommunicationDialog
			type="upgrade_request"
			ns="enterpriseRequest"
			trigger={
				<Button variant="outline" className="self-start">
					<Building2 className="size-4" />
					{t("trigger")}
				</Button>
			}
		/>
	);
}
